angular
  .module('contrast.services.alert', [])
  .factory('AlertService', function ($translate) {
    var translGlobal = {
      title_notificationsSettings_frequencyOnEvent: $translate.instant(
        'title_notificationsSettings_frequencyOnEvent'
      ),
      title_notificationsSettings_frequencyDaily: $translate.instant(
        'title_notificationsSettings_frequencyDaily'
      ),
      title_notificationsSettings_frequencyWeekly: $translate.instant(
        'title_notificationsSettings_frequencyWeekly'
      ),
      title_all_attacks: $translate.instant('title_all_attacks'),

      title_notificationsSettings_qualifierCategoryIs: $translate.instant(
        'title_notificationsSettings_qualifierCategoryIs'
      ),
      title_notificationsSettings_qualifierCategoryIsNot: $translate.instant(
        'title_notificationsSettings_qualifierCategoryIsNot'
      ),

      title_notificationsSettings_qualifierLikelihoodIs: $translate.instant(
        'title_notificationsSettings_qualifierLikelihoodIs'
      ),
      title_notificationsSettings_qualifierLikelihoodIsLowerThan:
        $translate.instant(
          'title_notificationsSettings_qualifierLikelihoodIsLowerThan'
        ),
      title_notificationsSettings_qualifierLikelihoodIsHigherThan:
        $translate.instant(
          'title_notificationsSettings_qualifierLikelihoodIsHigherThan'
        ),

      title_notificationsSettings_qualifierURLIs: $translate.instant(
        'title_notificationsSettings_qualifierURLIs'
      ),
      title_notificationsSettings_qualifierURLContains: $translate.instant(
        'title_notificationsSettings_qualifierURLContains'
      ),
      title_notificationsSettings_qualifierURLStartsWith: $translate.instant(
        'title_notificationsSettings_qualifierURLStartsWith'
      ),

      title_notificationsSettings_qualifierClassIs: $translate.instant(
        'title_notificationsSettings_qualifierClassIs'
      ),
      title_notificationsSettings_qualifierClassContains: $translate.instant(
        'title_notificationsSettings_qualifierClassContains'
      ),
      title_notificationsSettings_qualifierClassStartsWith: $translate.instant(
        'title_notificationsSettings_qualifierClassStartsWith'
      ),

      title_notificationsSettings_qualifierMethodIs: $translate.instant(
        'title_notificationsSettings_qualifierMethodIs'
      ),
      title_notificationsSettings_qualifierMethodContains: $translate.instant(
        'title_notificationsSettings_qualifierMethodContains'
      ),
      title_notificationsSettings_qualifierMethodStartsWith: $translate.instant(
        'title_notificationsSettings_qualifierMethodStartsWith'
      ),

      title_notificationsSettings_qualifierImpactIs: $translate.instant(
        'title_notificationsSettings_qualifierImpactIs'
      ),
      title_notificationsSettings_qualifierImpactIsLowerThan:
        $translate.instant(
          'title_notificationsSettings_qualifierImpactIsLowerThan'
        ),
      title_notificationsSettings_qualifierImpactIsHigherThan:
        $translate.instant(
          'title_notificationsSettings_qualifierImpactIsHigherThan'
        )
    }

    return {
      getFrequency: function () {
        return [
          {
            value: 'daily',
            text: translGlobal.title_notificationsSettings_frequencyDaily
          },
          {
            value: 'weekly',
            text: translGlobal.title_notificationsSettings_frequencyWeekly
          },
          {
            value: 'onevent',
            text: translGlobal.title_notificationsSettings_frequencyOnEvent
          }
        ]
      },
      getConditions: function () {
        return ['Category', 'Impact', 'Likelihood', 'URL', 'Class', 'Method']
      },
      getQualifierCategory: function () {
        return [
          {
            value: 'is',
            text: translGlobal.title_notificationsSettings_qualifierCategoryIs
          },
          {
            value: 'isnt',
            text: translGlobal.title_notificationsSettings_qualifierCategoryIsNot
          }
        ]
      },
      getQualifierLikelihood: function () {
        return [
          {
            value: 'is',
            text: translGlobal.title_notificationsSettings_qualifierLikelihoodIs
          },
          {
            value: 'lower',
            text: translGlobal.title_notificationsSettings_qualifierLikelihoodIsLowerThan
          },
          {
            value: 'higher',
            text: translGlobal.title_notificationsSettings_qualifierLikelihoodIsHigherThan
          }
        ]
      },
      getQualifierURL: function () {
        return [
          {
            value: 'is',
            text: translGlobal.title_notificationsSettings_qualifierURLIs
          },
          {
            value: 'contains',
            text: translGlobal.title_notificationsSettings_qualifierURLContains
          },
          {
            value: 'startswith',
            text: translGlobal.title_notificationsSettings_qualifierURLStartsWith
          }
        ]
      },
      getQualifierClass: function () {
        return [
          {
            value: 'is',
            text: translGlobal.title_notificationsSettings_qualifierClassIs
          },
          {
            value: 'contains',
            text: translGlobal.title_notificationsSettings_qualifierClassContains
          },
          {
            value: 'startswith',
            text: translGlobal.title_notificationsSettings_qualifierClassStartsWith
          }
        ]
      },
      getQualifierMethod: function () {
        return [
          {
            value: 'is',
            text: translGlobal.title_notificationsSettings_qualifierMethodIs
          },
          {
            value: 'contains',
            text: translGlobal.title_notificationsSettings_qualifierMethodContains
          },
          {
            value: 'startswith',
            text: translGlobal.title_notificationsSettings_qualifierMethodStartsWith
          }
        ]
      },
      getQualifierImpact: function () {
        return [
          {
            value: 'is',
            text: translGlobal.title_notificationsSettings_qualifierImpactIs
          },
          {
            value: 'lower',
            text: translGlobal.title_notificationsSettings_qualifierImpactIsLowerThan
          },
          {
            value: 'higher',
            text: translGlobal.title_notificationsSettings_qualifierImpactIsHigherThan
          }
        ]
      },
      getDetailLikelihood: function () {
        return ['Low', 'Medium', 'High']
      },
      getDetailImpact: function () {
        return ['Low', 'Medium', 'High']
      },
      getDetailCategory: function () {
        return [
          'Input Validation',
          'Authentication',
          'Session Management',
          'Caching',
          'Access Control',
          'Injection',
          'Secure Communications',
          'Cryptography',
          'XSS',
          'Availability',
          'Authorization'
        ]
      },
      convertToSymbols: function (word) {
        // TODO: CONTRAST-18297
        // eslint-disable-next-line default-case
        switch (word) {
          case 'is':
            return '='
          case 'isnt':
            return '!='
          case 'higher':
            return '>'
          case 'lower':
            return '<'
          case 'contains':
            return '=~'
          case 'startswith':
            return '^'
        }
      },
      changeOptionsArray: function (condition) {
        var self = this

        // TODO: CONTRAST-18297
        // eslint-disable-next-line default-case
        switch (condition.condition.toLowerCase()) {
          case 'category':
            condition.condition = 'Category'
            condition.qualifierArray = self.getQualifierCategory()
            condition.detailArray = self.getDetailCategory()
            condition.qualifier = 'is'
            condition.detail = 'Input Validation'
            condition.isInputDetail = false
            break
          case 'likelihood':
            condition.condition = 'Likelihood'
            condition.qualifierArray = self.getQualifierLikelihood()
            condition.detailArray = self.getDetailLikelihood()
            condition.qualifier = 'is'
            condition.detail = 'High'
            condition.isInputDetail = false
            break
          case 'impact':
            condition.condition = 'Impact'
            condition.qualifierArray = self.getQualifierImpact()
            condition.detailArray = self.getDetailImpact()
            condition.qualifier = 'is'
            condition.detail = 'High'
            condition.isInputDetail = false
            break
          case 'url':
            condition.condition = 'URL'
            condition.qualifierArray = self.getQualifierURL()
            condition.isInputDetail = true
            condition.qualifier = 'is'
            condition.detail = ''
            break
          case 'class':
            condition.condition = 'Class'
            condition.qualifierArray = self.getQualifierClass()
            condition.isInputDetail = true
            condition.qualifier = 'is'
            condition.detail = ''
            break
          case 'method':
            condition.condition = 'Method'
            condition.qualifierArray = self.getQualifierMethod()
            condition.isInputDetail = true
            condition.qualifier = 'is'
            condition.detail = ''
            break
        }
      },
      changeOptionsAttackArray: function (
        trigger,
        endAttackArray,
        changeAttackArray,
        intervalArrays
      ) {
        // TODO: CONTRAST-18297
        // eslint-disable-next-line default-case
        switch (trigger.name) {
          case 'NEW_ATTACK':
            trigger.statusArray = []
            trigger.statusArray.unshift({
              label: translGlobal.title_all_attacks,
              name: 'All'
            })
            trigger.status = []
            trigger.status.push(trigger.statusArray[0])
            break
          case 'END_ATTACK':
            trigger.statusArray = angular.copy(endAttackArray)
            trigger.statusArray.unshift({
              label: translGlobal.title_all_attacks,
              name: 'All'
            })
            trigger.status = []
            trigger.status.push(trigger.statusArray[0])
            break
          case 'CHANGE_STATUS':
            trigger.statusArray = angular.copy(changeAttackArray)
            trigger.statusArray.unshift({
              label: translGlobal.title_all_attacks,
              name: 'All'
            })
            trigger.status = []
            trigger.status.push(trigger.statusArray[0])
            break
          case 'EXPIRED_BLACKLIST':
            trigger.interval = 'EIGHT_HOURS'
            trigger.intervalsArray = intervalArrays
            break
        }
      },
      formatConditions: function (conditions) {
        var conds = []
        angular.forEach(conditions, function (condition) {
          conds.push({
            condition: condition.condition.toLowerCase(),
            qualifier: condition.qualifier,
            detail: condition.detail
          })
        })
        return conds
      },
      convertToAlertView: function (alert) {
        var alertView = {}
        var self = this
        alertView.name = alert.name
        alertView.description = alert.description
        alertView.frequency = alert.frequency
        alertView.tags = alert.tags
        alertView.conditions = []
        alertView.apps = []

        angular.forEach(alert.conditions, function (condition) {
          var item = {
            condition: condition.condition,
            qualifier: '',
            detail: '',
            qualifierArray: [],
            detailArray: [],
            isInputDetail: false
          }
          self.changeOptionsArray(item)
          item.qualifier = condition.qualifier
          item.detail = condition.detail
          alertView.conditions.push(item)
        })

        angular.forEach(alert.apps, function (app) {
          alertView.apps.push(app.app_id)
        })

        if (alert.allUsers) {
          alertView.allUsers = true
          alertView.recipients = ['All']
        } else {
          alertView.allUsers = false
          alertView.recipients = []
          alertView.recipients = alertView.recipients.concat(alert.recipients)
          alertView.recipients = alertView.recipients.concat(
            _.map(alert.users, 'uid')
          )
        }

        return alertView
      },
      convertToEditAlertAttackView: function (
        alert,
        entireApps,
        endAttackArray,
        changeAttackArray,
        intervalArrays
      ) {
        var alertView = {}
        alertView.name = alert.name
        alertView.description = alert.description
        alertView.recipients = alert.recipients
        alertView.tags = alert.tags
        alertView.apps = []
        alertView.triggers = []

        if (alert.allUsers) {
          alertView.allUsers = true
          alertView.recipients = ['All']
        } else {
          alertView.allUsers = false
          alertView.recipients = []
          alertView.recipients = _.map(alert.users, 'uid')
        }

        angular.forEach(alert.apps, function (app) {
          alertView.apps.push(app.app_id)
        })

        for (var i = 0; i < alert.triggers.length; i++) {
          var trigger = alert.triggers[i],
            j
          // TODO: CONTRAST-18297
          // eslint-disable-next-line default-case
          switch (trigger.name) {
            case 'NEW_ATTACK':
              trigger.statusArray = []
              trigger.statusArray.unshift({
                label: translGlobal.title_all_attacks,
                name: 'All'
              })
              trigger.status = []
              trigger.status.push(trigger.statusArray[0])
              break
            case 'END_ATTACK':
              trigger.status = []
              trigger.statusArray = angular.copy(endAttackArray)
              trigger.statusArray.unshift({
                label: translGlobal.title_all_attacks,
                name: 'All'
              })
              if (trigger.trigger_status.length == endAttackArray.length) {
                trigger.status.push(trigger.statusArray[0])
              } else {
                for (j = 0; j < trigger.trigger_status.length; j++) {
                  trigger.status.push(trigger.trigger_status[j].name)
                }
              }
              trigger.trigger_status = angular.copy(endAttackArray)
              break
            case 'CHANGE_STATUS':
              trigger.status = []
              trigger.statusArray = angular.copy(changeAttackArray)
              trigger.statusArray.unshift({
                label: translGlobal.title_all_attacks,
                name: 'All'
              })
              if (trigger.trigger_status.length == changeAttackArray.length) {
                trigger.status.push(trigger.statusArray[0])
              } else {
                for (j = 0; j < trigger.trigger_status.length; j++) {
                  trigger.status.push(trigger.trigger_status[j].name)
                }
              }
              trigger.trigger_status = angular.copy(changeAttackArray)
              break
            case 'EXPIRED_BLACKLIST':
              trigger.intervalsArray = intervalArrays
              trigger.interval = trigger.trigger_intervals[0].name
              trigger.trigger_intervals = angular.copy(intervalArrays)
              break
          }
          alertView.triggers.push(trigger)
        }

        return alertView
      },

      formatApplications: function (entireApps) {
        var apps = []
        angular.forEach(entireApps, function (app) {
          var item = { app_id: app.app_id, name: app.name, enabled: false }
          apps.push(item)
        })
        return apps
      },

      createAlertAttackRequest: function (alert) {
        var form = {}
        form.apps = alert.apps
        form.name = alert.name
        form.description = alert.description
        form.tags = alert.tags
        form.recipients = alert.recipients
        form.allUsers = alert.allUsers

        var selectedTriggers = [],
          j
        for (var i = 0; i < alert.triggers.length; i++) {
          var currentTrigger = alert.triggers[i]
          var trigger = {
            trigger: currentTrigger.name,
            intervals: [],
            status: []
          }
          if (!angular.isUndefined(currentTrigger.status)) {
            if (currentTrigger.status[0].name == 'All') {
              for (j = 0; j < currentTrigger.trigger_status.length; j++) {
                trigger.status.push(currentTrigger.trigger_status[j].name)
              }
            } else {
              for (j = 0; j < currentTrigger.status.length; j++) {
                trigger.status.push(currentTrigger.status[j])
              }
            }
          }

          if (!angular.isUndefined(currentTrigger.interval)) {
            trigger.intervals.push(currentTrigger.interval)
          }

          selectedTriggers.push(trigger)
        }
        form.triggers = selectedTriggers
        return form
      },
      removeEmptyConditions: function (alert) {
        var conditions = []
        angular.forEach(alert.conditions, function (condition) {
          if (condition.condition && condition.qualifier && condition.detail) {
            conditions.push(condition)
          }
        })
        alert.conditions = conditions
      }
    }
  })
